import Type from 'modules/Recommendations/CampaignsRecommendations/Type/Type'
import Reducer from 'modules/Recommendations/CampaignsRecommendations/Type/reducer'
import Sagas from 'modules/Recommendations/CampaignsRecommendations/Type/saga'

export default Type

export { Sagas, Reducer }
